<template>
  <v-sheet class="fill-height" tile color="white">
    <v-container fluid align="center">
      <v-row justify="center">
        <v-col cols="12" lg="4" md="6">
          <StoreTile
            mode="reservation_details"
            :reservation="reservation"
            :store="store"
          ></StoreTile>
          <v-spacer style="height: 3rem"></v-spacer>
        </v-col>
      </v-row>

      <v-row justify="center" v-if="active" class="qr-code">
        <v-col cols="12" lg="4" md="6" align="center">
          <canvas ref="canvas"></canvas>
        </v-col>
      </v-row>
      <v-row justify="center" v-if="canbeCancelled">
        <v-col cols="12" lg="4" md="6" align="center">
          <v-btn
            :loading="loadingState"
            outlined
            color="error"
            class="mb-4"
            @click="cancelReservation"
            >Cancel Reservation</v-btn
          >
        </v-col>
      </v-row>
      <v-row class="map-container-dense">
        <GmapMap
          :options="{
            streetViewControl: false,
            mapTypeControl: false,
            zoomControl: false,
            fullscreenControl: false,
            gestureHandling: 'none'
          }"
          :center="{ lat: store.lat, lng: store.lng }"
          :zoom="16"
          map-type-id="terrain"
        >
          <GmapMarker
            :clickable="false"
            :draggable="false"
            :position="{ lat: store.lat, lng: store.lng }"
          />
        </GmapMap>
      </v-row>
      <v-row>
        <v-list>
          <v-list-item>
            <v-list-item-icon>
              <v-icon color="primary">location_on</v-icon>
            </v-list-item-icon>

            <v-list-item-content>
              <v-list-item-title>{{ store.address }}</v-list-item-title>
            </v-list-item-content>
          </v-list-item>
          <v-divider inset></v-divider>
          <v-list-item>
            <v-list-item-icon>
              <v-icon color="primary">phone</v-icon>
            </v-list-item-icon>
            <v-list-item-content>
              <v-list-item-title>{{ store.phone }}</v-list-item-title>
            </v-list-item-content>
          </v-list-item>
          <v-divider inset></v-divider>
        </v-list>
      </v-row>
      <v-row style="padding: 20px">
        <StoreOpenTable :store="store" />
      </v-row>
    </v-container>
  </v-sheet>
</template>

<script>
import { mapGetters } from "vuex";
import StoreTile from "../Stores/StoreTile";
import { process_api_error } from "@/utils/utils";
import { RESERVATION_STATUS, determineStatusValue } from "../utils/constants";
import StoreDetails from "../Stores/StoreDetails";
import StoreOpenTable from "../Elements/StoreOpenTable";
import FullScreenMap from "../Elements/FullScreenMap";
import { doCancelReservation } from "../graphql/mutations";
import Storage from "@aws-amplify/storage";
var AWS = require("aws-sdk");

var QRCode = require("qrcode");

const moment = require("moment-timezone");

export default {
  name: "ReservationDetails",
  components: { FullScreenMap, StoreOpenTable, StoreDetails, StoreTile },
  data: function() {
    return {
      reservId: ""
    };
  },
  computed: {
    ...mapGetters(["loadingState", "getReservationById", "getStoreById"]),
    reservation() {
      this.reservId = this.getReservationById(
        this.$route.params.reservation_id
      );
      return this.getReservationById(this.$route.params.reservation_id);
    },
    store() {
      return this.getStoreById(this.reservation.store_id);
    },
    canbeCancelled() {
      var status = determineStatusValue(this.reservation, this.store);
      return status == RESERVATION_STATUS.ACTIVE;
    },
    active() {
      var status = determineStatusValue(this.reservation, this.store);
      return (
        status == RESERVATION_STATUS.ACTIVE ||
        status == RESERVATION_STATUS.IN_STORE ||
        status == RESERVATION_STATUS.AUTOEXIT
      );
    }
  },
  mounted() {
    if (this.active) {
      let rid = this.reservId.id;
      QRCode.toCanvas(
        this.$refs.canvas,
        this.reservation.id,
        {
          errorCorrectionLevel: "H",
          scale: 6
        },
        function(error, url) {
          if (error) {
            console.error(error);
          } else {
            
            var dataUrl = url.toDataURL("image/png");
            var binary = atob(dataUrl.split(",")[1]);
            var array = [];
            for (var i = 0; i < binary.length; i++) {
              array.push(binary.charCodeAt(i));
            }
            var blobData = new Blob([new Uint8Array(array)], {
              type: "image/png"
            });
            var params = {
              Key: rid,
              ContentType: "image/png",
              Body: blobData
            };
            console.log("data url : ", dataUrl);

            var bucket = new AWS.S3({
              accessKeyId: "AKIA4LQYRAKOKDJFESMJ",
              secretAccessKey: "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",
              region: "us-east-2",
              params: {
                Bucket: "spotsavermain50228-main/public/reservation",
                ACL: "public-read"
              }
            });

            bucket.upload(params, function(err, data) {
              if (err) {
                console.log("error : ", err);
              } else {
                // console.log("data : ", data);
              }
            });
          }
        }
      );
    }
  },
  methods: {
    convert_to_time(time_in_minutes) {
      if (time_in_minutes == 24 * 60) {
        return "12:00 PM";
      }
      var ap = [" AM", " PM"]; // AM-PM
      var hh = Math.floor(time_in_minutes / 60); // getting hours of day in 0-24 format
      var mm = time_in_minutes % 60; // getting minutes of the hour in 0-55 format
      var str =
        ("0" + (hh % 12)).slice(-2) +
        ":" +
        ("0" + mm).slice(-2) +
        ap[Math.floor(hh / 12)]; // pushing data in array in [00:00 - 12:00 AM/PM format]
      return str;
    },
    cancelReservation() {
      this.$store.dispatch("startLoading");
      this.$Amplify.API.graphql(
        this.$Amplify.graphqlOperation(doCancelReservation, {
          reservation_id: this.reservation.id,
          owner: this.reservation.owner
        })
      )
        .then(res => {
          this.$store.dispatch("stopLoading");
          this.$store.dispatch(
            "updateReservation",
            res.data.doCancelReservation
          );
        })
        .catch(e => {
          this.$store.dispatch("stopLoading");
          process_api_error(`Error Cancelling reservation`, e);
        });
    }
  }
};
</script>
<style lang="scss" scoped>
.v-list {
  width: 100%;

  .v-list-item__title {
    white-space: initial;
  }
}
</style>



// WEBPACK FOOTER //
// src/Reservations/ReservationDetails.vue